<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <linehaul-road-list-filter />
      <linehaul-road-list-header />
      <linehaul-road-list-table />
    </div>
  </div>
</template>

<script>

export default {
  name: 'LinehaulRoadList',
  computed: {
  }
}
</script>

<style>

</style>
